"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _context = require("../context");

var _Portal = _interopRequireDefault(require("./Portal"));

var _core = require("@emotion/core");

var fixedProps = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var ZIndexWrapper = (0, _context.styledWithTheme)('div')(function (_ref) {
  var theme = _ref.theme,
      zIndex = _ref.zIndex;
  return (0, _objectSpread2.default)({
    zIndex: theme.selectors.zIndex(zIndex)
  }, fixedProps);
});

var Backdrop = function Backdrop(_ref2) {
  var children = _ref2.children,
      opacity = _ref2.opacity,
      zIndex = _ref2.zIndex,
      dataTestComponent = _ref2.dataTestComponent;
  var bodyOverflow = (0, _react.useRef)('');

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var NEUTRAL90 = selectors.color('neutral90'); // Prevent content behind the backdrop from scrolling

  (0, _react.useEffect)(function () {
    bodyOverflow.current = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden'; // Reset the overflow on unmount

    return function () {
      document.body.style.overflow = bodyOverflow.current;
    };
  }, []);
  return (0, _core.jsx)(_Portal.default, null, (0, _core.jsx)(ZIndexWrapper, {
    zIndex: zIndex
  }, (0, _core.jsx)(_reactSpring.animated.div, {
    "data-test-component": dataTestComponent,
    style: (0, _objectSpread2.default)({}, fixedProps, {
      backgroundColor: NEUTRAL90,
      opacity: opacity
    })
  }), children));
};

Backdrop.displayName = 'Backdrop';
var _default = Backdrop;
exports.default = _default;